<template>
  <DashboardWidget class="w-100 h-100 dashboard-widget-valutazione-azienda no-overflow" title="Valutazione Azienda - Venture Capital Method">
      <div class="w-100 h-100 d-flex flex-column align-items-center justify-content-between">

      <FormContainer>
          <div class="row justify-content-center">
              <div class="col-6">
                <FormInputTextWidget class="mb-2" label="Multiplo" :min="0" type="number" v-model.number="multiplo"/>
                <b-button variant="link" id="mulitple-popover-trigger" class="p-0 text-muted">
                  <i class="fas fa-info-circle mr-1"></i>
                  <span class="small ">Che cos'è?</span>
                </b-button>
                <b-popover target="mulitple-popover-trigger" triggers="hover" placement="right">
                  <template v-slot:title>Multiplo</template>
                  <small>Il Multiplo è il rapporto EV/EBITDA (Enterprise Value / EBITDA) calcolato come media degli EV/EBITDA delle aziende appartenenti allo stesso settore che sono state sottoposte a valutazione in Europa. I multipli vengono pubblicati annualmente</small>
                </b-popover>
              </div>
              <div class="col-6">
                <FormInputPercentageWidget class="mb-2" label="Attualizzazione" v-model="attualizzazione"/>
                <b-button variant="link" id="attualizzazione-popover-trigger" class="p-0 text-muted">
                  <i class="fas fa-info-circle mr-1"></i>
                  <span class="small ">Che cos'è?</span>
                </b-button>
                <b-popover target="attualizzazione-popover-trigger" triggers="hover" placement="right">
                  <template v-slot:title>Attualizzazione</template>
                  <small>Il Tasso di attualizzazione dipende dallo stadio di sviluppo dell’azienda e rappresenta il rischio dell’investimento nel capitale dell’azienda stessa. Indicativamente il tasso viene determinato come segue: DEVELOPMENT - 70/80%, STARTUP - 60/70%, GROWTH  - 65/55%, EXPANSION - 60/40%, MATURITY - 50/30%</small>
                </b-popover>
              </div>
              <div class="col-12 col-xl-6 mt-3">
                <div class="form-control disabled bg-light text-center">
                  <template v-if="risultato === null">-</template>
                  <template v-else>
                    {{ risultato | money }}
                  </template>
                </div>
                <p class="small mb-1 text-center text-muted">Il valore calcolato è puramente indicativo</p>
              </div>
          </div>
      </FormContainer>
      </div>
  </DashboardWidget>
</template>

<script>

import { BButton, BPopover } from 'bootstrap-vue';
import formatMoneyFilter from '../../../../filters/formatMoney';

export default {
  components: {
    DashboardWidget: () => import('./DashboardWidget'),
    FormContainer: () => import('./../../../../libs/Form/components/FormContainer'),
    FormInputTextWidget: () => import('./../../../../libs/Form/components/Inputs/Widgets/FormInputTextWidget'),
    FormInputPercentageWidget: () => import('./../../../../libs/Form/components/Inputs/Widgets/FormInputPercentageWidget'),
    BButton,
    BPopover,
  },
  filters: {
    money: formatMoneyFilter,
  },
  props: {
    values: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      multiplo: this.values.multiplo || null,
      attualizzazione: this.values.attualizzazione || null,
    };
  },
  computed: {
    ebitda () {
      return this.values.ebitda || 0;
    },
    months () {
      return this.values.months || 0;
    },
    risultato () {
      if (!this.multiplo || !this.attualizzazione) {
        return null;
      }

      const tassoDiAttualizzazione = 1 / Math.pow(1 + (this.attualizzazione / 100), this.months / 12);

      return Math.floor(this.multiplo * this.ebitda * tassoDiAttualizzazione);
    },
  },
};

</script>

<style lang="scss">

.dashboard-widget-valutazione-azienda {
  label.form-label {
    margin-top: 0!important;
  }
}

</style>
